export default "__VITE_ASSET__BwOshByd__"